/* global $: false */

/**
 * Scroll To Top Button
 */
$( document ).ready(function() {
	'use strict';

	let scrollTop = $('.scroll-top');
	if (scrollTop.length > 0) {
		$(window).on('scroll', function() {
			if ($(window).scrollTop() >= $('#content').offset().top) {
				scrollTop.addClass('d-lg-block');
			} else {
				scrollTop.removeClass('d-lg-block');
			}
		});
		scrollTop.on('click', function(e) {
			e.preventDefault();
			$('html, body').animate(
				{
					scrollTop: $('body').offset().top
				},
				500
			);
		});
	}
});
